import React, { Component } from 'react';
import { HashRouter, Route } from 'react-router-dom';
import NotificationContainer from '../_components/notification/NotificationContainer';

import ConfigurationManager from '../_configuration/ConfigurationManager';

import Header from '../_components/header/Header'
import Home from '../home/Home';
import ProvissionLicensee from '../provission_licensee/ProvissionLicensee';
import ProvissionWB from '../provission_wb/ProvissionWB';

import './App.css';

class App extends Component {
  constructor(props) {
    super(props);

    this.state = {
      userName: 'Not logged in'
    }

    ConfigurationManager.environment = process.env;
  }

  get sessionInfo() {
    return this._sessionInfo;
  }
  
  render() {
    return(
      <HashRouter>
        <div className="main">
          <Header ref={ element => this._sessionInfo = element.sessionInfo } userName={ this.state.userName } onLoginClick={ this._handleLoginClick }></Header>
          <section className="content">
            <Route path="/home" render={ props => <Home parent={ this }></Home> }/>
            <Route path="/provision-licensee" render={ props => <ProvissionLicensee parent={ this }></ProvissionLicensee> }/>
            <Route path="/provision-wb" render={ props => <ProvissionWB parent={ this }></ProvissionWB> }/>
          </section>
          <NotificationContainer/>
        </div>
      </HashRouter>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/app/App.js